"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAdminUserDtoRolesEnum = void 0;
exports.instanceOfCreateAdminUserDto = instanceOfCreateAdminUserDto;
exports.CreateAdminUserDtoFromJSON = CreateAdminUserDtoFromJSON;
exports.CreateAdminUserDtoFromJSONTyped = CreateAdminUserDtoFromJSONTyped;
exports.CreateAdminUserDtoToJSON = CreateAdminUserDtoToJSON;
exports.CreateAdminUserDtoToJSONTyped = CreateAdminUserDtoToJSONTyped;
/**
 * @export
 */
exports.CreateAdminUserDtoRolesEnum = {
    Admin: 'admin',
    Superadmin: 'superadmin'
};
/**
 * Check if a given object implements the CreateAdminUserDto interface.
 */
function instanceOfCreateAdminUserDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    if (!('phone' in value) || value['phone'] === undefined)
        return false;
    if (!('roles' in value) || value['roles'] === undefined)
        return false;
    return true;
}
function CreateAdminUserDtoFromJSON(json) {
    return CreateAdminUserDtoFromJSONTyped(json, false);
}
function CreateAdminUserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'password': json['password'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'phone': json['phone'],
        'roles': json['roles'],
    };
}
function CreateAdminUserDtoToJSON(json) {
    return CreateAdminUserDtoToJSONTyped(json, false);
}
function CreateAdminUserDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'password': value['password'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'phone': value['phone'],
        'roles': value['roles'],
    };
}
